import { useQuery } from "@tanstack/react-query";
import { fetchMaterialPersonel } from "../api/fetchMaterialPersonel";

export const useMaterialPersonel = () => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["materialPersonel"],
    queryFn: fetchMaterialPersonel,
  });

  return {
    data: data?.result || [],
    error,
    isLoading,
    refetch,
  };
};

